"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MentionStyle = exports.MentionInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _recompose = require("recompose");
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _Avatar = _interopRequireDefault(require("../../Component/Avatar/Avatar"));
var _TokenPickerInput = _interopRequireWildcard(require("../TokenPickerInput/TokenPickerInput"));
var _excluded = ["classes"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type ComponentType } from 'react';*/ /*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var DISPLAY_NAME = 'MentionInput';
var MentionStyle = exports.MentionStyle = function MentionStyle(theme /*: ThemeType*/) {
  return {
    icon: {
      width: '1.5rem',
      height: '1.5rem',
      position: 'relative',
      marginRight: '.5rem'
    },
    fullName: _objectSpread(_objectSpread({}, theme.mixins.truncate), {}, {
      display: 'inline-block',
      marginRight: '.15rem',
      fontWeight: 700,
      maxWidth: _TokenPickerInput.MAX_WIDTH
    }),
    email: _objectSpread(_objectSpread({}, theme.mixins.truncate), {}, {
      maxWidth: _TokenPickerInput.MAX_WIDTH
    })
  };
};
/*:: export type MentionSuggestion = {
  display: string,
  email?: string,
  icon?: string
};*/
/*:: export type MentionInputType = InjectSheetProvidedProps &
  HTMLTextAreaElement & {
    data: Array<MentionSuggestion>,
    mentionInputClassName?: string
  };*/
var MentionInput = exports.MentionInput = /*#__PURE__*/function (_PureComponent) {
  function MentionInput() {
    (0, _classCallCheck2.default)(this, MentionInput);
    return _callSuper(this, MentionInput, arguments);
  }
  (0, _inherits2.default)(MentionInput, _PureComponent);
  return (0, _createClass2.default)(MentionInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      return /*#__PURE__*/_react.default.createElement(_TokenPickerInput.default, (0, _extends2.default)({
        appendSpaceOnAdd: true,
        markup: "[@__display__](/profile/__id__)",
        displayTransform: function displayTransform(id, display) {
          return "@".concat(display);
        },
        renderSuggestion: function renderSuggestion(suggestion /*: MentionSuggestion*/) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, suggestion.icon && /*#__PURE__*/_react.default.createElement(_Avatar.default, {
            image: suggestion.icon,
            className: classes.icon
          }), /*#__PURE__*/_react.default.createElement("span", {
            className: classes.fullName
          }, suggestion.display), suggestion.email && /*#__PURE__*/_react.default.createElement("span", {
            className: classes.email
          }, "(", suggestion.email, ")"));
        },
        trigger: "@"
      }, props));
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(MentionInput, "displayName", DISPLAY_NAME);
/*:: type EnhancedProps = {
  data: Function | Array<MentionSuggestion>,
  mentionInputClassName?: string
};*/
var EnhancedMentionInput /*: ComponentType<EnhancedProps>*/ = (0, _recompose.compose)((0, _recompose.setDisplayName)(DISPLAY_NAME), (0, _injectSheet.default)(MentionStyle))(MentionInput);
var _default = exports.default = EnhancedMentionInput;
//# sourceMappingURL=MentionInput.js.map